import { dummyAddresses } from "./address";
import type { UserData } from "../api/user";
import type { ApiResponse } from "../../types/api";

const dummyUser: UserData = {
  first_name: "John",
  last_name: "Doe",
  email: "developers@fooji.com",
  phone: "6466815300",
  metadata: {
    email_verified: ""
  },
  addresses: dummyAddresses
};

export const validateIdentifier = async (): Promise<ApiResponse> => Promise.resolve({ success: true });
export const getUser = async (): Promise<UserData | undefined> => Promise.resolve(dummyUser);
export const updateUser = async (): Promise<ApiResponse> => Promise.resolve({ success: true });
export const updateUserMetadata = async (): Promise<void> => Promise.resolve();
export const saveUserSettings = async (): Promise<ApiResponse> => Promise.resolve({ success: true });
export const validateEntry = async (): Promise<ApiResponse> => Promise.resolve({ success: true });
